import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ExtendSessionDialogComponent } from '../../shared/components/modals/mat-confirm-dialog/extend-session-dialog/extend-session-dialog.component';
import { MatConfirmDialogComponent } from '../../shared/components/modals/mat-confirm-dialog/mat-confirm-dialog/mat-confirm-dialog.component';



@Injectable({
  providedIn: 'root',
})
export class DialogService {
  constructor(private readonly dialog: MatDialog) { }

  //Modal Dialog para cancelar  o confirmar acción
  openConfirmDialog(data: {
    title?: string;
    message: string;
    confirmText?: string;
    cancelText?: string;
    timeout?: number;
  }) {
    return this.dialog.open(MatConfirmDialogComponent, {
      panelClass: 'confirm-dialog-container',
      disableClose: true,
      position: { top: '250px' },
      data,
    });
  }

  openExtendSessionDialog(countdown?: number): MatDialogRef<ExtendSessionDialogComponent> {
    return this.dialog.open(ExtendSessionDialogComponent, {
      width: '400px',
      disableClose: true,
      data: { countdown: countdown ?? 30 }
    });
  }
}
